import { Select } from 'antd'

const SelectComponent = props => {
  return <Select className="bytfc-formview-select" allowClear={true} {...props}></Select>
}

export default SelectComponent
